import { DataExportOptions } from './data-export-options';

/**
 * Data export options for XLSX format.
 */
export class XlsxDataExportOptions extends DataExportOptions {
	includeHeaders!: boolean;
	autoAdjustColumnWidths!: boolean;
}
